import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ_ITEMS = [
  {
    question: 'Kommt ihr wirklich bundesweit?',
    answer: 'Ja, wir arbeiten deutschlandweit. Die Begutachtung findet direkt vor Ort statt – Sie müssen nicht zu uns fahren.'
  },
  {
    question: 'Wie schnell bekomme ich einen Termin?',
    answer: 'Meist innerhalb von 24–48 Stunden, je nach Region und Verfügbarkeit. Wir koordinieren das flexibel mit Ihnen.'
  },
  {
    question: 'Muss ich irgendwo hinfahren?',
    answer: 'Nein. Die Begutachtung erfolgt dort, wo sich Ihr Fahrzeug befindet – bei Ihnen, in einer Werkstatt oder an einem anderen Ort Ihrer Wahl.'
  },
  {
    question: 'Was, wenn das Auto nicht fahrbereit ist?',
    answer: 'Kein Problem. Wir kommen dorthin, wo das Fahrzeug steht. Teilen Sie uns einfach den Standort mit.'
  },
  {
    question: 'Wie lange dauert die Begutachtung?',
    answer: 'In der Regel 30–60 Minuten vor Ort. Das schriftliche Gutachten erhalten Sie anschließend innerhalb von 2–3 Werktagen.'
  },
  {
    question: 'Was kostet ein Unfallgutachten?',
    answer: 'Die Kosten variieren je nach Schadensumfang und Fahrzeugtyp. Bei unverschuldetem Unfall werden sie oft von der gegnerischen Versicherung übernommen – einzelfallabhängig. Wir klären das gerne im Gespräch.'
  },
  {
    question: 'Wer übernimmt die Kosten?',
    answer: 'Bei unverschuldetem Unfall in der Regel die gegnerische Haftpflichtversicherung. Diese Information ist keine rechtsverbindliche Zusage – jeder Fall ist individuell zu prüfen.'
  },
  {
    question: 'Was passiert nach dem Termin?',
    answer: 'Nach der Begutachtung erstellen wir das Gutachten und senden es Ihnen zu. Sie können es dann bei der Versicherung einreichen.'
  },
  {
    question: 'Kann ich vorher Fragen stellen?',
    answer: 'Ja, selbstverständlich. Kontaktieren Sie uns per Telefon oder WhatsApp – wir klären alle offenen Punkte vorab.'
  },
  {
    question: 'Was brauche ich für den Termin?',
    answer: 'Idealerweise: Fahrzeugschein, Unfallbericht (falls vorhanden), Fotos. Aber keine Sorge – wenn etwas fehlt, klären wir das gemeinsam.'
  },
  {
    question: 'Wie wird der Termin abgestimmt?',
    answer: 'Nach Ihrer Kontaktaufnahme vereinbaren wir gemeinsam einen passenden Zeitpunkt und Ort. Flexibel nach Ihrer Verfügbarkeit.'
  },
  {
    question: 'Arbeitet ihr auch an Wochenenden?',
    answer: 'Je nach Verfügbarkeit und Region können Termine auch außerhalb der üblichen Geschäftszeiten abgestimmt werden. Sprechen Sie uns an.'
  }
];

export const FAQBundesweit = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            FAQ
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Häufig gestellte Fragen
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Antworten rund um bundesweite Begutachtungen
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-3xl p-10 lg:p-16 shadow-modern-lg">
          <Accordion type="single" collapsible className="w-full space-y-5">
            {FAQ_ITEMS.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`} 
                className="border border-gray-200 rounded-2xl px-7 py-1 data-[state=open]:border-brand-green/40 data-[state=open]:shadow-xl transition-all bg-white"
              >
                <AccordionTrigger className="text-left font-bold text-gray-900 hover:text-brand-green py-6 hover:no-underline text-base lg:text-lg">
                  <div className="flex items-start gap-4">
                    <HelpCircle className="w-6 h-6 text-brand-green flex-shrink-0 mt-0.5" />
                    <span className="pr-4">{item.question}</span>
                  </div>
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6 pl-10 text-[15px]">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="mt-10 text-center">
          <a href="/nach-dem-unfall" className="text-brand-green hover:text-brand-green-dark font-semibold text-lg transition-colors">
            Was tun nach einem Unfall? →
          </a>
        </div>
      </div>
    </section>
  );
};